import _ from 'lodash';
import {onBeforeMount, onBeforeUpdate, onUnmounted, getCurrentInstance} from 'vue'
import PersistanceService from "@/lib/tui/libs/persistanceService.js"
import * as globalConst from '@/lib/tui/libs/persistanceService.js'; 

export function t_subscribe(subArray)
{
  onBeforeMount(() => {

    let instance = getCurrentInstance();
    
    PersistanceService.log("DEBUG", "onBeforeMount ",instance, "("+instance.uid+")");

    if (!Array.isArray(subArray) || subArray.length <= 0)
    {
      PersistanceService.log("WARNING", instance, "("+instance.uid+") : subs is empty or null");
      return;
    }
    
    let PersisanceUpdate = function(request)
    { 
      let value = request.value;
      // Gère le cas d'un sous élement de liste supprimé coté backend
      // avant que le composant abonné sur ce noeud soit démonté
      // Attention aux effets de bords
      if (value === null)
        return;

      let config = PersistanceService.t.GetComponentConfig(instance.uid);
      let isLiveSub = false;

      for (let sub of config.subs)
      {
        if (sub.property === request.property)
        {
          if (sub.firstInitProperty)
            PersistanceService.t.SetComponentConfigProperty(instance.uid, request.property, "firstInitProperty", false);
          
          if (sub.type == globalConst.subTypeFlag.LIVE)
            isLiveSub = true;

          if (sub.filtersProperty && sub.filtersProperty.length >= 0)
          {
            if (Array.isArray(value))
            {
              let tmp = [];
              for (let el of value)
                tmp.push(_.pick(el, sub.filtersProperty));
              value = tmp;
            }
            else
              value = _.pick(value, sub.filtersProperty);
          }

          break;
        }
      }
      
      if (isLiveSub || !PersistanceService.DeepCompareObjects(value, instance.data[request.property], true))
      {
        PersistanceService.log("TRACE", "PersisanceUpdate ", instance, "("+instance.uid+") : ", request);
        instance.data[request.property] = _.clone(value);
        instance.update();
      }
    }

    let optSub = {
      uid: instance.uid,
      callback : PersisanceUpdate,
      subs: subArray
    };

    if (PersistanceService.t)
    {
      if (!PersistanceService.t.ComponentSubscribe(optSub))
      {
        PersistanceService.log("ERROR",instance, "("+instance.uid+") can't be mounted correctly due to a bad subscription");
        return;
      }
    }
    else
    {
      PersistanceService.log("ERROR",instance, "("+instance.uid+") can't be mounted correctly because persistance doesn't exist");
      return;
    }
  })
  onBeforeUpdate(() => {

    let instance = getCurrentInstance();
    let config = PersistanceService.t.GetComponentConfig(instance.uid);

    if (!config || !Object.prototype.hasOwnProperty.call(config, 'subs'))
      return;
    // TOFIX Dans le cas d'un v-if v-else, lorsque l'on umount un composant, on se retrouve avec un config undefined

    for (let sub of config.subs)
    {
      if (sub.firstInitProperty || sub.type == globalConst.subTypeFlag.LIVE || !sub.autoPubreq) 
        continue;
      
      let subPath = sub.path + (sub.index >= 0 ?"["+sub.index+"]" : "");
      let old_value = PersistanceService.t.getTreeValue(subPath);
      if (sub.filtersProperty && sub.filtersProperty.length >= 0)
      {
        if (Array.isArray(old_value))
        {
          let tmp = [];
          for (let el of old_value)
            tmp.push(_.pick(el, sub.filtersProperty));
          old_value = tmp;
        }
        else
          old_value = _.pick(old_value, sub.filtersProperty);
      }

      let new_value = instance.data[sub.property];

      if (!PersistanceService.DeepCompareObjects(old_value, new_value, true))
      {
        PersistanceService.log("TRACE", "onBeforeUpdate", instance, "(" + instance.uid + ") pubreq " + sub.path + " = ", instance.data[sub.property]);
        PersistanceService.t.pubreq(subPath, new_value);
      }
      
      if (!sub.optimistic)
        instance.data[sub.property] =  old_value;

      PersistanceService.t.SetComponentConfigProperty(instance.uid, sub.property, "inhibitedPubreq", false);
    }
  })
  onUnmounted(() => {
    
    let instance = getCurrentInstance();
    if (PersistanceService.t)
      PersistanceService.t.ComponentUnsubscribe(instance.uid);
    PersistanceService.log("DEBUG", "Unmounted ",instance, "(" + instance.uid+ ")");
  })
}